import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App.tsx';
// import { worker } from './mocks/browser';
import { seedInspections } from './lib/storage';

// Seed localStorage with sample inspections
seedInspections();

// MSW disabled - using real ML backend on localhost:5000
// To re-enable mock API: uncomment worker.start() below
/*
async function enableMocking() {
  return worker.start({
    onUnhandledRequest: 'bypass',
  });
}
enableMocking().then(() => {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>
  ));
});
*/

// Start app immediately with real backend
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
